export interface LanguageList {
    code: string;
    name: string;
}

const languageList: LanguageList[] = [
    { "code": "en", "name": "English" },
    { "code": "fr", "name": "French" }
]

export default languageList;